<div id="main" class="container" [formGroup]="form">

  <div id="alerts" *ngIf="alerts && alerts.length > 0" role="alert" aria-atomic="true" >
    <div *ngFor="let alter of alerts">{{alter.msg}}</div>
  </div>

  <div id="errors" *ngIf="errors && errors.length > 0" role="alert" aria-atomic="true" >
    <div *ngFor="let errore of errors"><span class="error-field">{{errore.field}}</span> - <span class="error-msg">{{errore.msg}}</span></div>
  </div>

  <h2><span style="color: rgb(0, 0, 70)">Pagamento </span>&nbsp;<span style="color: darkred;">ARISGAN</span></h2>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('codAccisa')}}</mat-label>
        <input formControlName="codAccisa" matInput #codAccisa type="text" [attr.aria-invalid]="codAccisaValid" (blur)="checkValidity(codAccisa, 'codAccisa')" >
      </mat-form-field>

      <input formControlName="totale" matInput type="hidden" >
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('ragioneSociale')}}</mat-label>
        <input formControlName="ragioneSociale" matInput #ragioneSociale type="text" [attr.aria-invalid]="ragioneSocialeValid"  (blur)="checkValidity(ragioneSociale, 'ragioneSociale')">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('cf')}}</mat-label>
        <input formControlName="cf" matInput #cf type="text" upperCase [attr.aria-invalid]="cfValid" (blur)="checkValidity(cf, 'cf')">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('email')}}</mat-label>
        <input formControlName="email" matInput #email type="text" [attr.aria-invalid]="emailValid" (blur)="checkValidity(email, 'email')">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('fkProvincia')}}</mat-label>
        <input formControlName="fkProvincia" matInput #fkProvincia type="text" [attr.aria-invalid]="fkProvinciaValid" (blur)="checkValidity(fkProvincia, 'fkProvincia')">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('fkComune')}}</mat-label>
        <input formControlName="fkComune" matInput #fkComune type="text" [attr.aria-invalid]="fkComuneValid" (blur)="checkValidity(fkComune, 'fkComune')">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('cap')}}</mat-label>
        <input formControlName="cap" matInput #cap type="text" maxlength="5" [attr.aria-invalid]="capValid" (blur)="checkValidity(cap, 'cap')">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('frazione')}}</mat-label>
        <input formControlName="frazione" matInput type="text">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('indirizzo')}}</mat-label>
        <input formControlName="indirizzo" matInput #indirizzo type="text" [attr.aria-invalid]="indirizzoValid" (blur)="checkValidity(indirizzo, 'indirizzo')">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('txtNumero')}}</mat-label>
        <input formControlName="txtNumero" matInput #txtNumero type="text" [attr.aria-invalid]="txtNumeroValid" (blur)="checkValidity(txtNumero, 'txtNumero')">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('fkNazione')}}</mat-label>
        <input formControlName="fkNazione" matInput #fkNazione type="text" [attr.aria-invalid]="fkNazioneValid" (blur)="checkValidity(fkNazione, 'fkNazione')">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label>{{getControlLabel('annoPagamento')}}</mat-label>
        <input formControlName="annoPagamento" matInput #annoPagamento type="number" [attr.aria-invalid]="annoPagamentoValid" (blur)="checkValidity(annoPagamento, 'annoPagamento')">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label mat-label>{{getControlLabel('meseVersamento')}}</mat-label>
        <mat-select formControlName="meseVersamento" matInput type="text" [attr.aria-invalid]='meseVersamentoValid()'>
          <mat-option value="Gennaio">Gennaio</mat-option>
          <mat-option value="Febbraio">Febbraio</mat-option>
          <mat-option value="Marzo">Marzo</mat-option>
          <mat-option value="Aprile">Aprile</mat-option>
          <mat-option value="Maggio">Maggio</mat-option>
          <mat-option value="Giugno">Giugno</mat-option>
          <mat-option value="Luglio">Luglio</mat-option>
          <mat-option value="Agosto">Agosto</mat-option>
          <mat-option value="Settembre">Settembre</mat-option>
          <mat-option value="Ottobre">Ottobre</mat-option>
          <mat-option value="Novembre">Novembre</mat-option>
          <mat-option value="Dicembre">Dicembre</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 pt-3 pb-3">
      Province *
    </div>
  </div>

  <div class="row" *ngIf="richiedentiFormsInitialized">
    <div class="col-6 col-md-3 col-lg-2 pb-3" *ngFor="let prov of _province">
      <mat-checkbox formControlName="{{prov.toLocaleLowerCase()}}Checkbox">{{prov}}</mat-checkbox>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <mat-form-field>
        <mat-label mat-label>{{getControlLabel('ravvedimento')}}</mat-label>
        <mat-select formControlName="ravvedimento" matInput type="text">
          <mat-option value="NO">NO</mat-option>
          <mat-option value="SI">SI</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngFor="let richiedente of richiedenti">
    <div class="row mb-2" *ngIf="form.get(richiedente.get('provincia')?.value?.toLocaleLowerCase()+'Checkbox')?.value">
      <div class="col-12" formArrayName="richiedenti" >
        <mat-expansion-panel expanded="true"
                             role="region"
                             aria-label="Importo tributo provincia"
                             matTooltip="Importo tributo provincia {{richiedente.get('provincia')?.value}}"
                             aria-expanded="true"
                             aria-controls="richiedenti-container"
                             id="richiedenti-container" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{richiedente.get('provincia')?.value}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container" [formGroup]="richiedente">
            <div class="row">
              <div class="col-12 col-lg-6">
                <mat-form-field>
                  <mat-label mat-label>{{getControlLabel('tipoTributo')}}</mat-label>
                  <mat-select formControlName="tipoTributo" matInput type="text">
                    <mat-option value="1">Addizionale</mat-option>
                    <!--
                    <mat-option value="2">Sostitutiva</mat-option>
                    <mat-option value="3">Addizionale e Sostitutiva</mat-option>
                    -->
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="richiedente.get('tipoTributo')?.value === '1' || richiedente.get('tipoTributo')?.value === '3'">
              <p style="font-size: 1.2em;" class="pt-2">Addizionale</p>
              <ng-container *ngIf="form.get('ravvedimento')?.value === 'NO'">
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('rataAddiz')}}</mat-label>
                    <input formControlName="rataAddiz" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'rata', 'Addiz')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('conguaglioAddiz')}}</mat-label>
                    <input formControlName="conguaglioAddiz" matInput type="number" (blur)="updateValoreTotali(richiedente, 'conguaglio', 'Addiz')">
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container *ngIf="form.get('ravvedimento')?.value === 'SI'">
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label mat-label>{{getControlLabel('tipoRavvedimentoAddiz')}}</mat-label>
                    <mat-select formControlName="tipoRavvedimentoAddiz" matInput type="text">
                      <mat-option value="rata">Rata</mat-option>
                      <mat-option value="conguaglio">Conguaglio</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('tributoAddiz')}}</mat-label>
                    <input formControlName="tributoAddiz" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'tributo', 'Addiz')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('sanzioneAddiz')}}</mat-label>
                    <input formControlName="sanzioneAddiz" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'sanzione', 'Addiz')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('interessiAddiz')}}</mat-label>
                    <input formControlName="interessiAddiz" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'interessi', 'Addiz')">
                  </mat-form-field>
                </div>
              </ng-container>
              <div class="col-12" style="font-size: 1.2em; font-weight: bold;">
                <label for="totaleAddiz">{{getControlLabel('totaleAddiz')}}</label>
                <input formControlName="totaleAddiz" style="border: none; text-align: right;"><span> €</span>
              </div>
            </div>
            <br><br>
            <div class="row" *ngIf="richiedente.get('tipoTributo')?.value === '2' || richiedente.get('tipoTributo')?.value === '3'">
              <p style="font-size: 1.2em;" class="pt-2">Sostitutiva</p>
              <ng-container *ngIf="form.get('ravvedimento')?.value === 'NO'">
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('rataSost')}}</mat-label>
                    <input formControlName="rataSost" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'rata', 'Sost')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('conguaglioSost')}}</mat-label>
                    <input formControlName="conguaglioSost" matInput type="number" (blur)="updateValoreTotali(richiedente, 'conguaglio', 'Sost')">
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container *ngIf="form.get('ravvedimento')?.value === 'SI'">
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label mat-label>{{getControlLabel('tipoRavvedimentoSost')}}</mat-label>
                    <mat-select formControlName="tipoRavvedimentoSost" matInput type="text">
                      <mat-option value="rata">Rata</mat-option>
                      <mat-option value="conguaglio">Conguaglio</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('tributoSost')}}</mat-label>
                    <input formControlName="tributoSost" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'tributo', 'Sost')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('sanzioneSost')}}</mat-label>
                    <input formControlName="sanzioneSost" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'sanzione', 'Sost')">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field>
                    <mat-label>{{getControlLabel('interessiSost')}}</mat-label>
                    <input formControlName="interessiSost" matInput type="number" min="0" (blur)="updateValoreTotali(richiedente, 'interessi', 'Sost')">
                  </mat-form-field>
                </div>
              </ng-container>
              <div class="col-12" style="font-size: 1.2em; font-weight: bold;">
                <label for="totaleSost">{{getControlLabel('totaleSost')}}</label>
                <input formControlName="totaleSost" style="border: none; text-align: right;"><span> €</span>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </div>
  </ng-container>
  <div class="col-12" style="font-size: 1.2em; font-weight: bold;">
    <label for="totale">{{getControlLabel('totale')}}</label>
    <input formControlName="totale" style="border: none; text-align: right;"><span> €</span>
  </div>
  <br>
  <re-captcha *ngIf="!isRiepilogo && recaptchaKey" class="re-captcha" (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
  <br>
  <div class="button-array">
    <button [ngClass]="{ 'indietro': isRiepilogo, 'indietro-disabled': !isRiepilogo }" (click)="indietro()" [disabled]="!isRiepilogo">Indietro</button>
    <button class="avanti" (click)="submit()">{{ !isRiepilogo ? 'Avanti' : 'Invia' }}</button>
  </div>
  <br>
</div>

